import { queryClient } from '@/libs/tanstack-query/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import React, { type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export function QueryProvider({ children }: Props) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
